package com.evoapps.evoshift.data.mapper

import com.evoapps.evoshift.data.dto.roster.RosterDto
import com.evoapps.evoshift.domain.model.Roster

class RosterMapper(
    private val rosterStatusMapper: RosterStatusMapper,
    private val metadataMapper: MetadataMapper
) {

    fun toDomain(dto: RosterDto): Roster {
        return Roster(
            id = dto.id,
            workplaceId = dto.workplaceId,
            month = dto.month,
            year = dto.year,
            status = rosterStatusMapper.toDomain(dto.status),
            currentVersion = dto.currentVersion ?: 0,
            metadata = metadataMapper.toDomain(dto.metadata),
            availabilityRequestId = dto.availabilityRequestId
        )
    }

    fun toDto(domain: Roster): RosterDto {
        return RosterDto(
            id = domain.id,
            workplaceId = domain.workplaceId,
            month = domain.month,
            year = domain.year,
            status = rosterStatusMapper.toDto(domain.status),
            currentVersion = domain.currentVersion,
            metadata = metadataMapper.toDto(domain.metadata),
            availabilityRequestId = domain.availabilityRequestId
        )
    }
}
